export enum InputCloneMode {
	ALWAYS = 'always',
	NEVER = 'never',
	FROM_NODE = 'from_node',
}
